<template>
  <div>
    <CRow>
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span class="font-weight-bold h6"> <CIcon name="cil-badge"/> {{ $t('idpReprot.reportIDP') }} </span>
          </CCardHeader>
          <CCardBody>


            <CRow>
              <CCol>
                <CDataTable
                    :table-filter="{label:''}"
                    :fields="fields"
                    :items="item"
                    :items-per-page="small ? 50 : 20"
                    :dark="dark"
                    :loading="loading"
                    pagination
                    :items-per-page-select="pages"
                    sorter
                >

                  <template #index="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                  </template>


                  <template #total="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.total }}
                    </td>
                  </template>


                  <template #value="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.value }} {{ '( ' + (((item.value) / item.total) * 100).toFixed(2) + '% )' }}
                    </td>
                  </template>

                  <template #pending="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.pending }} {{ '( ' + (((item.pending) / item.value) * 100).toFixed(2) + '% )' }}
                    </td>
                  </template>

                  <template #completed="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.completed }} {{ '( ' + (((item.completed) / item.value) * 100).toFixed(2) + '% )' }}
                    </td>
                  </template>

                  <template #progress="{item,index}">
                    <td class="text-center" @click="toggleDetails(item, index)">
                      {{ item.progress }} {{ '( ' + (((item.progress) / item.value) * 100).toFixed(2) + '% )' }}
                    </td>
                  </template>




<!--                  <template #complete="{item,index}">-->
<!--                    <td class="text-center" @click="toggleDetails(item, index)">-->
<!--&lt;!&ndash;                      {{ item.complete }} {{ '( ' + (((item.complete) / item.total) * 100).toFixed(2) + '% )' }}&ndash;&gt;-->
<!--                    </td>-->
<!--                  </template>-->

<!--                  <template #total="{item,index}">-->
<!--                    <td class="text-center" @click="toggleDetails(item, index)">-->
<!--                      {{ ((item.isGap / item.total) * 100).toFixed(2) }}-->
<!--                    </td>-->
<!--                  </template>-->

<!--                  <template #isMeets="{item,index}">-->
<!--                    <td class="text-center" @click="toggleDetails(item, index)">-->
<!--                      {{ item.isMeets }} {{ '( ' + (((item.isMeets) / item.total) * 100).toFixed(2) + '% )' }}-->
<!--                    </td>-->
<!--                  </template>-->

<!--                  <template #isExceeding="{item,index}">-->
<!--                    <td class="text-center" @click="toggleDetails(item, index)">-->
<!--                      {{ item.isExceeding }} {{ '( ' + (((item.isExceeding) / item.total) * 100).toFixed(2) + '% )' }}-->
<!--                    </td>-->
<!--                  </template>-->

                  <template #action="{item,index}">
                    <td style="width: 140px">
                      <CRow>
                        <CCol class="text-center">
                          <CButton class="mr-1" v-c-tooltip.hover.click="$t('reports.member')" size="sm" color="info" shape="pill" variant="outline" @click="toggleDetails(item,index)"  >
                            <CIcon name="cil-description"/>
                          </CButton>

                          <CButton  v-c-tooltip.hover.click="'Info'" size="sm" color="info" shape="pill" variant="outline" @click="toggleDetailsChart(item,index)"  >
                            <CIcon name="cil-list-rich"/>
                          </CButton>

                        </CCol>
                      </CRow>
                    </td>
                  </template>

                  <template #details="{item,index}">
<!--                    <CCollapse :show="Boolean(item._toggledC)" :duration="collapseDuration">-->
<!--                      <CCard class="bg-style mb-4 border-dark">-->
<!--                        <CCardHeader class="bg-gradient-dark text-white" >-->
<!--                          <span class="font-weight-bold h6">-->
<!--                            <CIcon name="cil-people" class="mr-2"/>-->
<!--                            <label class="font-weight-bold"> {{ $t('reports.member') }} </label>-->
<!--                          </span>-->
<!--                        </CCardHeader>-->
<!--                        <CCardBody>-->
<!--                          <Method_IDP1 :item="objse"/>-->
<!--                        </CCardBody>-->
<!--                      </CCard>-->
<!--                    </CCollapse>-->

                    <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">

                      <CCard class="bg-style mb-4 border-dark">
                        <CCardHeader class="bg-gradient-dark text-white" >
                          <span class="font-weight-bold h6">
                            <CIcon name="cil-people" class="mr-2"/>
                            <label class="font-weight-bold"> {{ $t('reports.member') }} </label>
                          </span>
                        </CCardHeader>
                        <CCardBody>
                          <CDataTable
                              :table-filter="{label:''}"
                              :fields="subfields"
                              :items="item.history"
                              :items-per-page="small ? 50 : 20"
                              :dark="dark"
                              :loading="loading"
                              pagination
                              :items-per-page-select="pages"
                              sorter
                          >

                            <template #index="{item,index}">
                              <td class="text-center" @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                            </template>
                            <template #levels="{item,index}">
                              <td class="text-center" @click="toggleDetails(item, index)"> {{ item.levels  }}</td>
                            </template>
                          </CDataTable>
                        </CCardBody>
                      </CCard>

                    </CCollapse>
                  </template>
                </CDataTable>
              </CCol>
              <CCol col="12">
                <CDropdownDivider/>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>


import Method_IDP1 from "@/projects/views/E-Performances/Reports/components/Methods1.vue";
import {mapGetters} from "vuex";
import IDPInfomation from "@/projects/views/E-Performances/IndividualDevelopmentPlan/components/IDPInfomation.vue";

export default {
  name: "ReportCompetencyIDP",
  components: {IDPInfomation, Method_IDP1},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    item: {
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#", _style: 'width:50px; text-align: center'},
          {key: "title", label: "ประเภทสมรรถนะ"},
          {key: "total", label: "Total", _style: 'width:150px; text-align: center'},
          {key: "value", label: "Count", _style: 'width:150px; text-align: center'},
          {key: "pending", label: "Pending", _style: 'width:150px; text-align: center'},
          {key: "progress", label: "In Progress", _style: 'width:150px; text-align: center'},
          {key: "completed", label: "Complete", _style: 'width:100px; text-align: center'},
          // {key: "isMeets", label: "Meets Expectations ", _style: 'width:150px; text-align: center'},
          // {key: "isWithin", label: "Within Expectations", _style: 'width:150px; text-align: center'},
          // {key: "isExceeding", label: "Exceeds Expectations", _style: 'width:150px; text-align: center'},
          {key:"action", label: "#", _style: 'width:20px; text-align: center'}
        ]
      }
    },

    subfields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#", _style: 'width:50px; text-align: center'},
          {key:"accounts", label:"Name"},
          {key:"levels", label:"Level", _style: 'width:50px; text-align: center'},
          {key:"assessor", label:"Assessor"},
          {key: "state", label:"Status"}
          // {key: "isWithin", label: "Within Expectations", _style: 'width:150px; text-align: center'},
          // {key: "isExceeding", label: "Exceeds Expectations", _style: 'width:150px; text-align: center'},
          // {key:"action", label: "#", _style: 'width:20px; text-align: center'}
        ]
      }
    },


    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,

    pages: {
      type: Object,
      default() {
        return {
          values: [10, 20, 50, 100]
        }
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
  },

  mounted() {

  },

  created() {
    this.init()

  },
  beforeDestroy() {

  },
  data() {
    return {
      collapseDuration: 0,

      objse:[],

    }
  },
  methods:{
    init(){
      var body = {};
      body.year = this.option.year;
      body.agency = this.option.agency;

      this.$store.dispatch("report/status", body);
    },

    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})

      // this.$emit('info',item)
    },

    toggleDetailsChart(item,index) {
      item._toggledC = !item._toggledC
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})

      // this.$emit('info',item)
    },
  },
  computed: {
    ...mapGetters({
      lang: "setting/lang",
      rStatus: "report/status",
    }),

  },
  watch:{
    rStatus(value){
      var lang = this.$store.getters['setting/lang']
      this.objse =  value.map(item => ({
        title: item.title.filter(objs => { return objs.key === lang })[0].value,
        value: item.value,
        total: item.total,
        // completed: item.completed,
        // progress: item.progress,

        history: item.historys.map(history => ({
          ...history,
          accounts:history.accounts.accounts.userinfo.prefix.filter(objs => { return objs.key === lang })[0].value+' '+history.accounts.accounts.userinfo.firstName.filter(objs => { return objs.key === lang })[0].value+' '+history.accounts.accounts.userinfo.lastName.filter(objs => { return objs.key === lang })[0].value,
          assessor:history.assessor.accounts.accounts.userinfo.prefix.filter(objs => { return objs.key === lang })[0].value+' '+history.assessor.accounts.accounts.userinfo.firstName.filter(objs => { return objs.key === lang })[0].value+' '+history.assessor.accounts.accounts.userinfo.lastName.filter(objs => { return objs.key === lang })[0].value,

          state:history.status.at(-1).state.title.filter(objs => { return objs.key === lang })[0].value,
          status:history.status.at(-1).state,
        })),

        pending : item.historys.filter( item => { return (item.status.at(-1).state._id.toString() === "654851a37ab25be71bbeeed6") }).length,
        completed : item.historys.filter( item => { return (item.status.at(-1).state._id.toString() === "67bfc7ed24e13ba338b58e4d") }).length,
        progress : item.historys.filter( item => { return (item.status.at(-1).state._id.toString() !== "654851a37ab25be71bbeeed6" && item.status.at(-1).state._id.toString() !== "67bfc7ed24e13ba338b58e4d") }).length,



      }))
    }
  }
}
</script>

<style scoped>

</style>
